'use client';
import { Modal } from '@benzinga/core-ui';
import { StockSymbol } from '@benzinga/session';
import { SessionContext } from '@benzinga/session-context';
import { MarketingWin, MarketingWinsManager } from '@benzinga/marketing-wins-manager';
import React from 'react';
import { MarketingWinItem } from './MarketingWinItem';

export const WinsModal: React.FC<{
  onClose: () => void;
  onSymbolClick: (symbol: StockSymbol) => void;
  winId: string;
}> = props => {
  const session = React.useContext(SessionContext);
  const winsManager = session.getManager(MarketingWinsManager);
  const [win, setWin] = React.useState<MarketingWin | undefined>(undefined);
  React.useEffect(() => {
    winsManager.getWins().then(wins => {
      const win = wins.ok?.find(win => win.id === props.winId);
      setWin(win);
    });
  }, [props.winId, winsManager]);

  return (
    <Modal
      disableFullScreenButton={true}
      onClose={props.onClose}
      size={{ manual: { height: 'auto', width: '500px' } }}
      title={'Win Details'}
    >
      <MarketingWinItem onSymbolClick={props.onSymbolClick} win={win} />
    </Modal>
  );
};
